import { RightCircleOutlined } from "@ant-design/icons";
import { Flex, HStack, Text } from "@chakra-ui/react";
import { Button, Card } from "antd";
import { CustomerRoutes } from "appRoutePaths";
import ConfirmEmailAddress from "components/customer/Profile/ConfirmEmailAddress";
import EnableMFA from "components/customer/Profile/EnableMFA";
import FullScreenSpinner from "components/FullScreenSpinner";
import { useLogin } from "hooks/useLogin";
import useProfile from "hooks/useProfile";
import { useNavigate } from "react-router";

const MandatoryCustomerMFA = () => {
    const { data: profile, isLoading } = useProfile();
    const navigate = useNavigate();
    const { refreshAuthToken } = useLogin();

    const goToDashboard = async () => {
        await refreshAuthToken();
        navigate(CustomerRoutes.dashboard.url, { replace: true });
    }

    if (isLoading || !profile) {
        return <FullScreenSpinner />;
    }

    return <Flex alignItems="center" justifyContent="center" m={70}>
        <Card style={{ borderRadius: '16px' }}>
            <Flex direction='column'>
                <Text fontSize="4xl" mb={5}>Mandatory Two-Factor Authentication</Text>
                <Text fontSize="2xl" mb={5}>To heighten security on your account, please proceed with setting up two factor authentication.</Text>

                <HStack
                    bg="lightGray"
                    rounded={5}
                    p={4}
                    alignItems='center'
                    justifyContent='center'
                >
                    {profile.verifiedEmail ? (
                        <Button type="link" disabled>Email Address Confirmed</Button>
                    ) : (
                        <ConfirmEmailAddress email={profile.email} />
                    )}
                    <RightCircleOutlined style={{ color: '#000', fontSize: '18px' }} />
                    <EnableMFA
                        onEnabled={goToDashboard}
                        emailConfirmed={profile.verifiedEmail}
                        disabledText="Two-factor requires email confirmation"
                    />
                </HStack>

                <Text fontSize="2xl" mt={5}>Once two-factor has been setup, you will be redirected to your dashboard.</Text>
            </Flex>
        </Card>
    </Flex>;
}

export default MandatoryCustomerMFA;